export type VaultPageAlertType = 'success' | 'error' | 'info' | 'warning';

export interface VaultPageAlertRenderItem {
  id: number;
  type: VaultPageAlertType;
  title: string;
  message: string;
}

/** Construye la fila visible del alert de pantalla (recrea instancia para autoClose del kit). */
export function buildVaultPageAlertRenderItems(
  message: string | null | undefined,
  type: VaultPageAlertType,
  title: string,
  nextId: () => number,
): VaultPageAlertRenderItem[] {
  const msg = (message || '').trim();
  if (!msg) {
    return [];
  }
  return [{ id: nextId(), type, title, message: msg }];
}
